import React from "react";
import ErrorField from "./error";
import Big from "big.js";
import { CurrencyField } from "components/support";
import { observer } from "mobx-react";

const CostValueField = ({ errors, row, onChange }) => {
  const { cost_value } = row;
  let parsedCostValue = "0.00";
  if (cost_value && cost_value.length !== 0) {
    parsedCostValue = Big(cost_value)
      .div(100)
      .toFixed(2);
  }
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.cost_value;

  return (
    <div>
      <CurrencyField
        value={parsedCostValue}
        onChange={(_, value) =>
          onChange(
            Big(value)
              .times(100)
              .toFixed(0)
          )
        }
        unit="R$ "
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.cost_value} />}
    </div>
  );
};

export default observer(CostValueField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/cost-value.js